export default {
  methods: {
    refreshButton (time = 3000) {
      setTimeout(() => {
        this.buttonKey = this.$uuidKey()
      }, time)
    }
  }
}
